import { RemoteData } from 'app/infrastructure/remote-data/remote-data';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { CaseData, ApiResponse } from 'app/types-shared';
import { endpoint } from './endpoints';
import { BussinesType } from './constants';
import { WireBowtieData, BowtieLayout, Codetable, WireChecklistEvaluationData } from './types';
import { ConnectedCasesModel } from './types-store';

export const api = {

  loadBowtie: async (
    caseNumber: number,
    includeConnectedCases: boolean,
    draftOriginalCase: number,
    favouriteId: number
  ): Promise<WireBowtieData> => {

    const request = await new RemoteData(endpoint.bowtie(caseNumber))
      .resource<ApiResponse<WireBowtieData>>()
      .filter({
        includeConnectedCases,
        ...(isDefinedIncludingZero(draftOriginalCase) && { caseIdToIgnoreWhenCountingOtherConnections: draftOriginalCase }),
        connectedCasesFilterFavourite: favouriteId
      })
      .single();

    return request.data;
  },

  loadLayout: async (): Promise<BowtieLayout> => {

    const request = await new RemoteData(endpoint.layout)
      .resource<ApiResponse<BowtieLayout>>()
      .single();

    return request.data;
  },

  loadDraft: async (id: number): Promise<CaseData> => {

    const request = await new RemoteData(endpoint.draft).resource<ApiResponse<CaseData>>()
      .withId(id)
      .single();

    return request.data;
  },

  loadEvaluation: async (caseId: number, favouriteId: number): Promise<WireChecklistEvaluationData[]> => {

    const request = await new RemoteData(endpoint.linkedCheckListEvaluations)
      .resource<ApiResponse<WireChecklistEvaluationData[]>>()
      .filter({ caseId, filterFavouriteId: favouriteId })
      .single();

    return request.data;
  },

  loadConnectedCases: async (
    caseNumbers: number[],
    connectionTypes: number[],
    favouriteId?: number
  ): Promise<ConnectedCasesModel[]> => {
    const request = await new RemoteData(endpoint.connectedCases)
      .resource<ApiResponse<ConnectedCasesModel[]>>()
      .filter({ caseId: caseNumbers, connectionTypeId: connectionTypes, 
        ...(favouriteId && { filterFavouriteId: favouriteId }) })
      .single();

    return request.data;
  },

  loadDraftConnectionOptions: async (id: number): Promise<Codetable> => {

    const request = await new RemoteData(endpoint.connections(id)).resource<ApiResponse<Codetable>>()
      .filter({ businessType: BussinesType.generalCategory })
      .single();

    return request.data;
  },

  addDraftConnection: async (draftId: number, connectedCaseId: number, connectionTypeId: number) => {
    await new RemoteData(`${endpoint.draft}/${draftId}/connections`)
      .resource<any>()
      .filter({
        caseId: connectedCaseId,
        connectionTypeId
      })
      .create({});
  },

  removeDraftConnection: async (draftId: number, connectedCaseId: number, connectionTypeId: number) => {
    await new RemoteData(`${endpoint.draft}/${draftId}/connections`)
      .resource<any>()
      .filter({
        caseId: connectedCaseId,
        connectionTypeId
      })
      .httpDelete({});
  },

  createBowtieFavourite: async (queryParameters?: {[key:string]: string | number}) => {
    const response = await new RemoteData(endpoint.createBowtieFavourite)
      .resource<any>()
      .filter({
        ...queryParameters
      })
      .create(undefined, false);

    const json = await response.json();
    
    return json.data;
  }
};
